var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-red-600 text-sm",attrs:{"role":"button"},on:{"click":_vm.showRemoveRoleDialog}},[_vm._v("Remove")])
}
var staticRenderFns = []

export { render, staticRenderFns }